import { createReducer, on } from "@ngrx/store";
import { toggleDarkMode } from "./darkmode.actions";

// TODO: this should be saved with the users details and retrieved on load
export const initialState = (localStorage.getItem('darkMode') === 'true') ?? false;

export const darkModeReducer = createReducer(
    initialState,
    on(toggleDarkMode, (state) => !state)
)